import { TypeContext } from '../context/typs'

import { useContext, useMemo } from 'react'
import service from '../../../@services'
import { inventoryTypeEnum } from '../config'
export default function useBillTypeContext() {
  const { type, no, stockType } = useContext(TypeContext)
  const { baseQueryModule } = useMemo(() => {
    return {
      baseQueryModule:
        service[type === inventoryTypeEnum.IN ? 'stockIn' : 'stockOut']
    }
  }, [type])
  return {
    type,
    no,
    stockType,
    baseQueryModule
  }
}
